import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {DialogData} from "../../../models/dialog-data.model";
import {TranslateModule} from "@ngx-translate/core";
import {ButtonComponent} from "../button/button.component";
import { DatePipe, NgTemplateOutlet } from "@angular/common";
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: "app-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.css"],
    imports: [NgTemplateOutlet, ButtonComponent, DatePipe, TranslateModule]
})
export class DialogComponent {
  today: Date = new Date();
  restrictionDate: Date = null;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    public authService: AuthService
  ) {
    if (data.restrictionDate) {
      this.restrictionDate = new Date(data.restrictionDate);
    }
  }

  close() {
    this.dialog.closeAll();
    if (this.data.type === 'closeBrowser'){
      this.authService.clearIsLoggedOut();
    }
  }
}
